module.exports = __webpack_public_path__ + "img/herramientas.57ac95b7.svg";